import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/AuthContext";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenziali non valide");
    } finally { setLoading(false); }
  };

  const input = "w-full rounded-xl bg-white border border-[#292522]/12 px-4 py-3 focus:border-[#FF6100] focus:ring-2 focus:ring-[#FF6100]/20 outline-none text-sm";

  return (
    <div className="min-h-screen bg-[#FFF1E8] flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-6"><Logo size="lg" /></div>
        <div className="card-vv p-8 bg-white">
          <h1 className="font-display text-3xl font-medium">Area riservata</h1>
          <p className="mt-1 text-sm text-[#292522]/60">Accesso amministrativo</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <label className="block"><span className="text-xs font-semibold text-[#292522]/70">Email</span>
              <input required type="email" className={input + " mt-1"} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
            </label>
            <label className="block"><span className="text-xs font-semibold text-[#292522]/70">Password</span>
              <input required type="password" className={input + " mt-1"} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" />
            </label>
            <button disabled={loading} className="btn-primary w-full justify-center" data-testid="admin-login-submit">{loading ? "Accesso…" : "Entra"}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
